import type { AxiosResponse } from 'axios';

import { API_URL } from '@/config/env';
import { conformanceApi } from '@/lib/api';

import type {
  AddManagedAppRequest,
  AppSearchResult,
  ManagedApp,
} from './access.types';

/**
 * Application-access service (Pegasus app allowlist + Entra admin-consent read).
 *
 * Calls the Conformance ApplicationManagementController @ `api/v4.0/system/applications`:
 *   GET    /system/applications/search?q=          -> AppSearchResult[]
 *   GET    /system/applications                     -> ManagedApp[]
 *   POST   /system/applications                     -> ManagedApp
 *   PUT    /system/applications/{appId}/roles       -> ManagedApp
 *   DELETE /system/applications/{appId}             -> 204
 */
const APPS_BASE = `${API_URL.replace('/orr', '')}/system/applications`;

export const searchApps = (
  q: string,
): Promise<AxiosResponse<AppSearchResult[]>> =>
  conformanceApi.get<AppSearchResult[]>(`${APPS_BASE}/search`, { params: { q } });

export const getManagedApps = (): Promise<AxiosResponse<ManagedApp[]>> =>
  conformanceApi.get<ManagedApp[]>(APPS_BASE);

export const addManagedApp = (
  body: AddManagedAppRequest,
): Promise<AxiosResponse<ManagedApp>> =>
  conformanceApi.post<ManagedApp>(APPS_BASE, body);

export const updateManagedAppRoles = (
  appId: string,
  roles: string[],
): Promise<AxiosResponse<ManagedApp>> =>
  conformanceApi.put<ManagedApp>(
    `${APPS_BASE}/${encodeURIComponent(appId)}/roles`,
    { roles },
  );

export const removeManagedApp = (
  appId: string,
): Promise<AxiosResponse<void>> =>
  conformanceApi.delete<void>(`${APPS_BASE}/${encodeURIComponent(appId)}`);
